import angular from 'angular';

import Component from './calendar-all-day-event.component';

const CalendarAllDayEvent = angular
    .module('control-room.commons.data.components.calendar.components.calendar-all-day-event', [])
    .component('crCalendarAllDayEvent', Component);

export default CalendarAllDayEvent;
